export const getSchemaInDestinationMetricSchema =
  'getSchemaInDestinationMetricSchema';
export const getTablesInDestinationMetricSchema =
  'getTablesInDestinationMetricSchema';
export const getColumnsForTablesInDestinationMetricSchema =
  'getColumnsForTablesInDestinationMetricSchema';
